import { h, Component } from 'preact';
import style from './style';
import PhotoGallery from 'react-photo-gallery';

export default class Gallery extends Component {
	render() {
		return (
			<div class={style.gallery}>
				<PhotoGallery photos={PHOTO_SET} lightboxShowImageCount={true} />
			</div>
		);
	}
}

const PHOTO_SET = [
	{
		src: '/assets/images/768/bd-work-01.jpg',
		width: 768,
		height: 576,
		aspectRatio: 1.333,
		lightboxImage : {
			src: '/assets/images/fullsize/bd-work-01.jpg',
			srcset: [
				'/assets/images/1280/bd-work-01.jpg 1280w',
				'/assets/images/768/bd-work-01.jpg 768w',
				'/assets/images/320/bd-work-01.jpg 320w'
			],
			caption: 'Bowl with birds, impressed and painted decoration, multiple slips and glazes, stoneware, 230mm diam.'
		}
	},
	{
		src: '/assets/images/768/bd-work-02.jpg',
		width: 768,
		height: 576,
		aspectRatio: 1.333,
		lightboxImage : {
			src: '/assets/images/fullsize/bd-work-02.jpg',
			srcset: [
				'/assets/images/1280/bd-work-02.jpg 1280w',
				'/assets/images/768/bd-work-02.jpg 768w',
				'/assets/images/320/bd-work-02.jpg 320w'
			],
			caption: 'Triple bowl, impressed and painted decoration, Multiple slips and glazes, stoneware, 300mm diam.'
		}
	},
	{
		src: '/assets/images/768/bd-work-03.jpg',
		width: 768,
		height: 576,
		aspectRatio: 1.333,
		lightboxImage : {
			src: '/assets/images/fullsize/bd-work-03.jpg',
			srcset: [
				'/assets/images/1280/bd-work-03.jpg 1280w',
				'/assets/images/768/bd-work-03.jpg 768w',
				'/assets/images/320/bd-work-03.jpg 320w'
			],
			caption: 'Deep oval bowl with a cut foot, impressed and painted decoration, multiple slips and glazes, stoneware, 330mm diam.'
		}
	},
	{
		src: '/assets/images/768/bd-work-04.jpg',
		width: 768,
		height: 576,
		aspectRatio: 1.333,
		lightboxImage : {
			src: '/assets/images/fullsize/bd-work-04.jpg',
			srcset: [
				'/assets/images/1280/bd-work-04.jpg 1280w',
				'/assets/images/768/bd-work-04.jpg 768w',
				'/assets/images/320/bd-work-04.jpg 320w'
			],
			caption: 'Pheasants platter, painted slips, mixed hardwood Nuka type glaze, stoneware, 380mm diam.'
		}
	},
	{
		src: '/assets/images/768/bd-work-05.jpg',
		width: 768,
		height: 576,
		aspectRatio: 1.333,
		lightboxImage : {
			src: '/assets/images/fullsize/bd-work-05.jpg',
			srcset: [
				'/assets/images/1280/bd-work-05.jpg 1280w',
				'/assets/images/768/bd-work-05.jpg 768w',
				'/assets/images/320/bd-work-05.jpg 320w'
			],
			caption: 'Wide Himeji vase, slab built, impressed and painted decoration, multiple slips and glazes, stoneware, 270mm high.'
		}
	},
	{
		src: '/assets/images/768/kd-work-01.jpg',
		width: 768,
		height: 1024,
		aspectRatio: 0.75,
		lightboxImage : {
			src: '/assets/images/fullsize/kd-work-01.jpg',
			srcset: [
				'/assets/images/1280/kd-work-01.jpg 1280w',
				'/assets/images/768/kd-work-01.jpg 768w',
				'/assets/images/320/kd-work-01.jpg 320w'
			],
			caption: 'Celtisch flagon, Rutile and copper/chrome slips, sgraffito decoration, ashtree ash Nuka type glaze, stoneware, 500mm high.'
		}
	},
	{
		src: '/assets/images/768/kd-work-02.jpg',
		width: 768,
		height: 1024,
		aspectRatio: 0.75,
		lightboxImage : {
			src: '/assets/images/fullsize/kd-work-02.jpg',
			srcset: [
				'/assets/images/1280/kd-work-02.jpg 1280w',
				'/assets/images/768/kd-work-02.jpg 768w',
				'/assets/images/320/kd-work-02.jpg 320w'
			],
			caption: 'Baluster type jug, Copper/chrome slip under mixed hardwood Nuka type glaze, stoneware, 400 mm high.'
		}
	},
	{
		src: '/assets/images/768/kd-work-03.jpg',
		width: 768,
		height: 576,
		aspectRatio: 1.333,
		lightboxImage : {
			src: '/assets/images/fullsize/kd-work-03.jpg',
			srcset: [
				'/assets/images/1280/kd-work-03.jpg 1280w',
				'/assets/images/768/kd-work-03.jpg 768w',
				'/assets/images/320/kd-work-03.jpg 320w'
			],
			caption: 'Moon bowl, thrown and altered, Copper/ chrome slip rim with resist brushwork, elm ash Nuka type glaze, stoneware, 380mm diam.'
		}
	},
	{
		src: '/assets/images/768/kd-work-04.jpg',
		width: 768,
		height: 576,
		aspectRatio: 1.333,
		lightboxImage : {
			src: '/assets/images/fullsize/kd-work-04.jpg',
			srcset: [
				'/assets/images/1280/kd-work-04.jpg 1280w',
				'/assets/images/768/kd-work-04.jpg 768w',
				'/assets/images/320/kd-work-04.jpg 320w'
			],
			caption: 'Fruit/ salad bowl with handles, Copper/cobalt slip with resist brushwork, mixed hardwood ash Nuka type glaze, stoneware, 340mm diam.'
		}
	},
	{
		src: '/assets/images/768/kd-work-05.jpg',
		width: 768,
		height: 576,
		aspectRatio: 1.333,
		lightboxImage : {
			src: '/assets/images/fullsize/kd-work-05.jpg',
			srcset: [
				'/assets/images/1280/kd-work-05.jpg 1280w',
				'/assets/images/768/kd-work-05.jpg 768w',
				'/assets/images/320/kd-work-05.jpg 320w'
			],
			caption: 'Platter, Copper/chrome slip with resist brushwork, mixed hardwood Nuka type glaze, stoneware, 380mm diam.'
		}
	}
];



// WEBPACK FOOTER //
// ./components/gallery/index.js